/**
 * example would be if user tries to enter long in a tradeplan he set up as go short. in the example given, the user clicked enter now to go long, but his tradeplan 
 * was configured to go short. We would block this user action
 * {
	"messageType": "alertNotification",
	"notificationId": 1645464945686,
	"notificationDetails": {"errorType":"USER_ACTION","notificationType":"ERROR","userAction":"ENTER_NOW","userActionDetails":null,"TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "ENTRY_CONTRADICTS_TRADE_PLAN_DIRECTION",
	"statusDetails": {"userDesiredToGoLong":true,"tradePlanGoLong":false},
	"date": "2022-02-21T12:35:46.514-0500",
	"timestamp": "1645464946514"
}

 * @param {*} statusDetails 
 * @returns an object with field
 * 1) userDesiredToGoLong: did the user click goLong or goShort? this field being false means the user clicked goShort
 * 2) tradePlanGoLong: was the tradeplan long or short? If this is false, then the trade plan is configured to go short
 */
export function entryContradictsTradePlanDirectionParser(statusDetails) {
  const parsedObj = {
    userDesiredToGoLong: null,
    tradePlanGoLong: null,
  };
  if (statusDetails) {
    parsedObj.userDesiredToGoLong = statusDetails.userDesiredToGoLong ?? null;
    parsedObj.tradePlanGoLong = statusDetails.tradePlanGoLong ?? null;
  }

  return parsedObj;
}
